var exports = {
  "kL": "xf0b3b88a--966854--container",
  "Ql": "xf0b3b88a--966854--container_high_rate",
  "Kg": "xf0b3b88a--966854--container_low_rate",
  "Q6": "xf0b3b88a--966854--header_bar",
  "YB": "xf0b3b88a--966854--columns",
  "Jh": "xf0b3b88a--966854--left_column",
  "_S": "xf0b3b88a--966854--right_column",
  "_k": "xf0b3b88a--966854--general_info",
  "M1": "xf0b3b88a--966854--stats",
  "TS": "xf0b3b88a--966854--rate",
};

module.exports = exports;
